export default __webpack_public_path__ + "static/media/facebook.2dd5bdd2.svg";